(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-customer-care"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-faq-care]');
    const input = root?.querySelector('.aepinbh-faq-search input[type="search"]');
    if (!root || !input) return;
    const items = [...root.querySelectorAll('[data-faq-item]')].map((item) => ({
      element: item,
      group: item.closest('.aepinbh-faq-grid > div'),
    }));
    const groups = [...new Set(items.map(({ group }) => group).filter(Boolean))];
    const empty = document.createElement('p');
    empty.hidden = true;
    empty.setAttribute('role', 'status');
    empty.textContent = 'No matching questions found.';
    root.querySelector('.aepinbh-faq-groups')?.prepend(empty);
    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      let visible = 0;
      items.forEach(({ element, group }) => {
        const groupText = group?.querySelector('h3')?.textContent || '';
        const matches = !query || `${groupText} ${element.textContent}`.toLowerCase().includes(query);
        element.hidden = !matches;
        if (matches) visible += 1;
        if (!matches) element.open = false;
      });
      groups.forEach((group) => {
        group.hidden = query && !items.some(({ element, group: itemGroup }) => itemGroup === group && !element.hidden);
      });
      empty.hidden = visible > 0;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
